import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { ModelOpenWidgetComponent } from '../../../widget/model-open-widget/model-open-widget.component';
import { RedirectWidgetComponent } from '../../../widget/redirect-widget/redirect-widget.component';
import { PolicySelectorWidgetComponent } from '../../../widget/policy-selector-widget/policy-selector-widget.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, DragDropModule } from '@angular/cdk/drag-drop';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { ActionWidgetService } from '@services/widget/action-widget.service';
import { WidgetContent } from '@models/widget/widget-content.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, DragDropModule, PolicySelectorWidgetComponent, RedirectWidgetComponent, ModelOpenWidgetComponent, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-action-widget',
  templateUrl: './action-widget.component.html',
  styleUrls: ['./action-widget.component.css'],
})
export class ActionWidgetComponent implements OnInit {
  customerWidgets$!: Observable<WidgetContent[]>;

  customizeWidgetsModalOptions: ModalOptions;
  actionWidgets: WidgetContent[];
  customizedWidgets: WidgetContent[] = [null, null, null, null];
  draggedWidgetId: string;

  isAcmic: boolean;
  hideModal: boolean;

  constructor(
    private acmicService: AcmicService,
    private widgetService: ActionWidgetService
  ) {
    this.hideModal = false;
  }

  public ngOnInit() {
    window.addEventListener("beforeunload", () => this.widgetService.saveLastActivitiesAsWidgets())
    this.isAcmic = this.acmicService.isACMIC();
    this.initWidgets();
    this.setModalOptions();
  }

  initWidgets() {
    this.customerWidgets$ = this.widgetService.customerWidgets$.pipe(
      map(widgets => {
        if (widgets.length === 4) {
          this.customizedWidgets = [...widgets];
          const idsToRemove = new Set(widgets.map(widget => widget.id));
          this.actionWidgets = this.widgetService.getAllWidgets().filter(widget => !idsToRemove.has(widget.id))
          return widgets
        } else {
          this.customizedWidgets = [null, null, null, null];
          this.actionWidgets = this.widgetService.getAllWidgets();
          return this.widgetService.getDefaultWidgets();
        }
      })
    );
  }

  setModalOptions() {
    this.customizeWidgetsModalOptions = new ModalOptions({
      additionalButtonClasses: 'customize-tile',
      additionalClasses: 'customize-widgets modal-xl modal-dialog modal-center-on-page modal-dialog-scrollable',
      buttonCopy: 'Customize',
      modalId: 'customizeWidgetsModal',
      size: 'modal-lg',
      typeOfModal: 'default',
      modalName: 'customize_Widgets_Modal',
    });
  }

  saveCustomWidget() {
    this.widgetService.saveCustomActionWidgets(this.customizedWidgets);
    this.initWidgets();
  }

  hideModalAction(event): void {
    void event;
    this.hideModal = !this.hideModal;
    this.initWidgets();
  }

  onModalClick() {
    this.hideModal = false;
    this.initWidgets();
  }

  onDragStarted(widget: WidgetContent) {
    this.draggedWidgetId = widget.id;
  }

  onDragEnded() {
    this.draggedWidgetId = null;
  }

  onDrop(event: CdkDragDrop<WidgetContent[]>): void {
    const { previousContainer, container } = event;

    if (event.previousContainer === event.container) {
      return;
    }

    const targetMatch = container.id.match(/\d+(?!.*\d)/);
    const targetIndex = targetMatch ? Number(targetMatch[0]) : null;

    const sourceMatch = previousContainer.id.match(/\d+(?!.*\d)/);
    const sourceIndex = sourceMatch ? Number(sourceMatch[0]) : null;

    if (container.id.startsWith("customizedWidget") && previousContainer.id.startsWith("customizedWidget")) {
      this.swapWidget(sourceIndex, targetIndex);
    } else if (previousContainer.id.startsWith("customizedWidget") && sourceIndex !== null) {
      this.deleteCustomizeWidget(sourceIndex);
    } else if (container.id.startsWith("customizedWidget") && targetIndex !== null) {
      this.addCustomizeWidgetBy(targetIndex, event.item.data);
    } else {
      return;
    }

    this.draggedWidgetId = null;
  }

  swapWidget(sourceIndex: number, targetIndex: number): void {
    if (targetIndex === null || sourceIndex === null) {
      return;
    }
    [this.customizedWidgets[sourceIndex], this.customizedWidgets[targetIndex]]
      = [this.customizedWidgets[targetIndex], this.customizedWidgets[sourceIndex]];
  }

  deleteCustomizeWidget(widgetIndex: number): void {
    const sourceWidget = this.customizedWidgets[widgetIndex];
    this.customizedWidgets[widgetIndex] = null;

    this.actionWidgets.push(sourceWidget);
    this.actionWidgets.sort((a, b) => a.position - b.position);
  }

  addCustomizeWidgetBy(index: number, widgetToAdd: WidgetContent): void {
    this.actionWidgets = this.actionWidgets.filter(widget => widget.id !== widgetToAdd.id);

    if (this.customizedWidgets[index]) {
      const widgetToUpdate = this.customizedWidgets.splice(index, 1, widgetToAdd)[0];
      this.actionWidgets.push(widgetToUpdate);
      this.actionWidgets.sort((a, b) => a.position - b.position);
    } else {
      this.customizedWidgets[index] = widgetToAdd;
    }
  }
}
